import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import WeddingInvitationPage from './pages/WeddingInvitationPage';
import AdminPage from './pages/AdminPage';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<WeddingInvitationPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </Router>
  );
};

export default App;
